import React from "react";
import Flex from "Components/Flex.js";
import {CircularProgress} from "@material-ui/core";

export default ({FlexProps, disableCentre, size, small}) => (
	<Flex fullCentre={!disableCentre} {...FlexProps}>
		<CircularProgress disableShrink={true} size={(size || (small ? 21 : undefined))} />
	</Flex>
);
